import React from 'react'
import classes from '../styles.module.scss'
import { useKato } from '../../../../contexts/kato.context';
import { getImageById } from '../../../../requests/public.request';
import { getLang } from '../../../../helpers/utils';
import { PhoneIcon } from '../../../../assets/icons';
import { useTranslation } from 'react-i18next';
import { monthsKz, monthsRu } from '../../../../consts/other.conts';

export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const lang = getLang();
  const months = lang === 'Kz' ? monthsKz : monthsRu;
  const month = months[monthIndex];

  return `${day} ${month} ${year}`;
};

const Akim = () => {
  const { generalInfo } = useKato()?.katoGeneralInfo || {};
  const { t } = useTranslation()

  if (!generalInfo) return null;
  const akimName = generalInfo[`akimName${getLang()}`];
  const akimSurname = akimName?.split(' ')[0] || '';
  const akimRestname = akimName?.split(' ').slice(1).join(' ') || '';
  const akimPosition = generalInfo[`akimPosition${getLang()}`] || '';
  if(!akimName || !akimPosition) return null;
  return (
    <div className={classes.akim}>
      <div className={classes.akim__photo}>
        <img src={getImageById(generalInfo.akimImageId)} alt={akimName || ''} />
      </div>
      <div className={classes.akim__info}>
        <div className={classes.akim__name}>
          <span className={classes.akim__surname}>{akimSurname}</span>
          <span >{akimRestname}</span>
        </div>

        <div className={classes.akim__position}>{akimPosition}</div>

        <div className={classes.akim__contacts}>
          <div className={classes.akim__positionFrom}>
            <span>{t('akim.inPositionFrom')}</span>
            <span className={classes.akim__date}>{formatDate(generalInfo.akimInPositionFrom)}</span>
          </div>
          <div className={classes.akim__phone}>
            <span className={classes.akim__phone_icon}><PhoneIcon /></span>
            <span>{generalInfo.akimPhone}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Akim